import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content sub" }
const _hoisted_4 = { style: {"height":"auto"} }
const _hoisted_5 = { class: "body_content" }
const _hoisted_6 = {
  key: 0,
  style: {"margin-top":"30px"}
}
const _hoisted_7 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 0,
  class: "examinee-creation-section"
}
const _hoisted_10 = {
  key: 1,
  style: {"margin-top":"10px","text-align":"center","color":"#888"}
}
const _hoisted_11 = {
  key: 1,
  style: {"text-align":"center","padding":"20px","color":"#888"}
}
const _hoisted_12 = { style: {"margin-top":"30px","text-align":"right","margin-left":"80px","min-width":"800px","max-width":"1000px"} }

import { ref, onMounted, h, onUnmounted } from "vue";
import MyPageSidebar from "@/views/member/MypageSidebar.vue";
// import Banner from "@/components/Banner.vue"; // Banner is commented out in template
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter, useRoute } from "vue-router";
import {
  NSpace,
  NCard,
  NButton,
  NDescriptions,
  NDescriptionsItem,
  NDataTable,
  DataTableColumns,
  useNotification,
  useMessage,
  useDialog,
  NIcon,
  NInput,
  NTag,
  NTooltip,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import {
  getCallable,
  getCallableOption,
  getRequestEndpoint,
} from "@/config/env";
import * as common from "@/assets/common/common";
import { getAuth } from "firebase/auth";
import * as constant from "@/constants/constant";
import { Order, OrderItem } from "@/model/order";
import { Project } from "@/model/project";
import { Examinee } from "@/model/examinee";
import { useDownload } from "@/composables/useDownload";
import { getProjectStatusString } from "@/composables/useOrderForm";
import { RefreshOutline as RefreshIcon } from "@vicons/ionicons5";

interface ExamineeTableProps {
  examinees: Examinee[];
  classType?: string;
  project?: Project;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PersonalOrderProjectDetail',
  setup(__props) {

const { downloadReportFile } = useDownload();

const router = useRouter();
const route = useRoute();
const notification = useNotification();
const message = useMessage();
const dialog = useDialog();
const auth = getAuth();

const pageLoading = ref(true);
const orderProjectEntries = ref<Project[]>(); // Changed to Project[] for clarity
const isDoingJob = ref(false);
const isStudentReporting = ref<{ [key: string]: boolean }>({});
const isProjectClosing = ref<{ [key: string]: boolean }>({});
const isDownloadingStudentReport = ref<{ [key: string]: boolean }>({});
const isSendingStudentEmail = ref<{ [key: string]: boolean }>({});

const getOrderProjectsCallable = getCallable(
  "getOrderProjectsContainsExamninees"
);
const requestProjectReportGenerationCallable = getCallableOption(
  "requestProjectReportGeneration"
);
const closeOneProjectCallable = getCallable("closeOneProject");
const openOneProjectCallable = getCallable("openOneProject");
const sendExamineeReportEmailCallable = getCallable("sendExamineeReportEmail");
const updateExamineeEmailCallable = getCallable("updateExamineeEmail");


async function fetchOrderProjectDetails(orderSK: string, silent = false) {
  if (!silent) {
    pageLoading.value = true;
  }
  try {
    const result = await getOrderProjectsCallable({ SK: orderSK });
    if (common.evalFunctionResult(result)) {
      const orderProjectData = common.getItemListFromFunctionResult(
        result
      ) as Project[];
      if (orderProjectData && orderProjectData.length > 0) {
        orderProjectEntries.value = orderProjectData;
      } else {
        notification.warning({
          title: "정보 없음",
          description: "해당 진단 정보를 찾을 수 없습니다.",
          duration: 3000,
        });
      }
    } else {
      console.error("검사 결과 로딩 실패:", common.getResultError(result));
      notification.error({
        title: "로딩 실패",
        description:
          common.getResultError(result) ||
          "검사 결과를 불러오는 중 오류가 발생했습니다.",
        duration: 3000,
      });
    }
  } catch (error: any) {
    console.error("검사 결과 정보 로딩 실패:", error);
    notification.error({
      title: "로딩 실패",
      description: error || "검사 결과를 불러오는 중 오류가 발생했습니다.",
      duration: 3000,
    });
  } finally {
    pageLoading.value = false;
  }
}

async function refreshData() {
  const orderSKFromRoute = route.params.SK as string;
  if (orderSKFromRoute) {
    await fetchOrderProjectDetails(orderSKFromRoute);
  }
}

let isComponentMounted = true;
let refreshInterval: any = null;

onMounted(async () => {
  isComponentMounted = true;
  pageLoading.value = true;
  const orderSKFromRoute = route.params.SK as string;

  if (!orderSKFromRoute) {
    pageLoading.value = false;
    notification.error({
      title: "오류",
      description: "신청 정보가 올바르지 않습니다. 신청 목록으로 돌아갑니다.",
      duration: 3000,
    });
    router.push({ name: USER_ROUTES.ORDER_LIST.NAME }); // Or a default order list route
    return;
  }
  await fetchOrderProjectDetails(orderSKFromRoute);

  if (isComponentMounted) {
    refreshInterval = setInterval(async () => {
      const currentSK = route.params.SK as string;
      if (currentSK) {
        await fetchOrderProjectDetails(currentSK, true);
      }
    }, 15000);
  }
});

onUnmounted(() => {
  isComponentMounted = false;
  if (refreshInterval) {
    clearInterval(refreshInterval);
    refreshInterval = null;
  }
});

const getClassTitle = (classItem: Project, classIdx: number): string => {
  return `상세 정보`;
};

const createExamineeTableColumns = (
  classType?: string,
  project?: Project
): DataTableColumns<Examinee> => {
  const isUniversityType = classType === "putt_u" || classType === "tec";
  return [
    {
      title: "학생 정보 및 결과리포트 / 이메일 관리",
      key: "examinee_info",
      render: (row, idx) => {
        const isSent = !!row.email_sent;
        const hasEmail = !!row.email;
        const numLabel = isUniversityType ? "학번" : "번호";
        const numVal = isUniversityType
          ? row.student_num || row.num || "N/A"
          : row.num || "N/A";

        // 1행: 인증코드 | 번호/학번 | 성명 (성별 / 생년월일)
        const row1 = h(
          "div",
          {
            style: {
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "8px",
              paddingBottom: "8px",
              borderBottom: "1px dashed #e8e8e8",
              fontSize: "13px",
            },
          },
          [
            // 인증코드
            h(
              "span",
              { style: { display: "inline-flex", alignItems: "center", gap: "4px" } },
              [
                h("span", { style: { color: "#666" } }, "인증코드:"),
                h(
                  "strong",
                  { style: { color: "#e03131", letterSpacing: "0.5px", fontSize: "14px" } },
                  row.authCode || "N/A"
                ),
              ]
            ),
            h("span", { style: { color: "#d9d9d9" } }, "|"),
            // 번호 / 학번
            h(
              "span",
              { style: { display: "inline-flex", alignItems: "center", gap: "4px" } },
              [
                h("span", { style: { color: "#666" } }, `${numLabel}:`),
                h(
                  "span",
                  {
                    style: {
                      fontWeight: numVal !== "N/A" ? "bold" : "normal",
                      color: numVal !== "N/A" ? "#333" : "#999",
                    },
                  },
                  numVal
                ),
              ]
            ),
            h("span", { style: { color: "#d9d9d9" } }, "|"),
            // 성명 및 인적사항
            h(
              "span",
              { style: { fontWeight: "bold", fontSize: "14px", color: "#1f2225" } },
              row.name || "N/A"
            ),
            h(
              "span",
              { style: { color: "#666" } },
              `(${common.getGenderString(row.gender)} / ${row.dob || "생년월일 미등록"})`
            ),
          ]
        );


        // 2행: 결과리포트 및 이메일 전송/수정 영역
        let row2;
        if (row.report_file) {
          let tooltipText = "전송완료";
          if (row.email_sent_at) {
            try {
              const d = new Date(row.email_sent_at);
              if (!isNaN(d.getTime())) {
                tooltipText = `${common.formatDateToYYYYMMDD2(d)} 전송됨`;
              }
            } catch {}
          }

          row2 = h(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: "12px",
                paddingTop: "8px",
              },
            },
            [
              // 좌측: 이메일 정보 & 전송 상태
              h(
                "div",
                { style: { display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" } },
                [
                  h(
                    "div",
                    { style: { display: "flex", alignItems: "center", gap: "6px" } },
                    [
                      h("span", { style: { fontSize: "13px", color: "#666" } }, "이메일:"),
                      h(
                        "span",
                        {
                          style: {
                            fontSize: "13px",
                            fontWeight: row.email ? "500" : "normal",
                            color: row.email ? "#1f2225" : "#999",
                          },
                        },
                        row.email || "미등록"
                      ),
                      h(
                        NButton,
                        {
                          size: "tiny",
                          quaternary: true,
                          type: "primary",
                          onClick: () => showEmailEditDialog(row),
                        },
                        { default: () => "수정" }
                      ),
                    ]
                  ),
                  h("span", { style: { color: "#d9d9d9" } }, "|"),
                  h(
                    "div",
                    { style: { display: "flex", alignItems: "center", gap: "6px" } },
                    [
                      h("span", { style: { fontSize: "13px", color: "#666" } }, "전송상태:"),
                      isSent
                        ? h(
                            NTooltip,
                            { trigger: "hover" },
                            {
                              trigger: () =>
                                h(
                                  NTag,
                                  { type: "success", size: "small", round: true, style: "cursor: pointer;" },
                                  { default: () => "전송완료" }
                                ),
                              default: () => tooltipText,
                            }
                          )
                        : h(
                            NTag,
                            {
                              size: "small",
                              round: true,
                              bordered: false,
                              style: "color: #999; background: #f0f0f0;",
                            },
                            { default: () => "미전송" }
                          ),
                    ]
                  ),
                ]
              ),
              // 우측: 결과리포트 액션 버튼들
              h(
                "div",
                { style: { display: "flex", alignItems: "center", gap: "8px" } },
                [
                  h(
                    NButton,
                    {
                      strong: true,
                      tertiary: true,
                      size: "small",
                      disabled: isDoingJob.value,
                      loading: isDownloadingStudentReport.value[row.SK] || false,
                      onClick: () => downloadExamineeReportFile(row, classType),
                    },
                    { default: () => "리포트 다운로드" }
                  ),
                  h(
                    NTooltip,
                    { trigger: "hover" },
                    {
                      trigger: () =>
                        h(
                          NButton,
                          {
                            type: isSent ? "warning" : "info",
                            size: "small",
                            disabled: !hasEmail || isDoingJob.value,
                            loading: isSendingStudentEmail.value[row.SK],
                            onClick: () => doSendExamineeEmail(row, project),
                          },
                          { default: () => (isSent ? "이메일 재전송" : "이메일 전송") }
                        ),
                      default: () =>
                        !hasEmail
                          ? "이메일 주소를 입력해주세요"
                          : isSent
                          ? "결과리포트 이메일 재전송"
                          : "결과리포트 이메일 전송",
                    }
                  ),
                ]
              ),
            ]
          );
        } else if (row.is_report_generating) {
          row2 = h(
            "div",
            { style: { paddingTop: "8px" } },
            [
              h(
                NButton,
                { strong: true, tertiary: true, size: "small", disabled: true, loading: true },
                { default: () => "결과리포트 생성 중..." }
              ),
            ]
          );
        } else {
          row2 = h(
            "div",
            { style: { paddingTop: "8px" } },
            [
              h(
                NTag,
                { size: "small", bordered: false, style: "color: #999; background: #f7f7f7;" },
                { default: () => "진단 미완료 (결과리포트 생성 전)" }
              ),
            ]
          );
        }

        return h(
          "div",
          {
            style: {
              padding: "10px 14px",
              background: "#fafafa",
              borderRadius: "6px",
              border: "1px solid #f0f0f0",
            },
          },
          [row1, row2]
        );
      },
    },
  ];
};

// 학생 정보 테이블을 위한 간단한 함수형 컴포넌트
const ExamineeTable: FunctionalComponent<ExamineeTableProps> = (props) => {
  const columns = createExamineeTableColumns(props.classType, props.project);
  return h(NDataTable, {
    columns: columns,
    data: props.examinees,
    bordered: false,
    singleLine: false,
    size: "small",
    style: { marginTop: "15px" },
  });
};

function triggerOrderProjectsUpdate() {
  if (orderProjectEntries.value) {
    orderProjectEntries.value = orderProjectEntries.value.map((p) => ({
      ...p,
      examinees: p.examinees ? [...p.examinees] : [],
    }));
  }
}

function showEmailEditDialog(examinee: Examinee) {
  const newEmailRef = ref<string>(examinee.email || "");
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const d = dialog.create({
    title: "학생 이메일 수정",
    content: () =>
      h("div", { style: "display: flex; flex-direction: column; gap: 8px;" }, [
        h("p", `"${examinee.name}" 학생의 이메일 주소를 입력해주세요.`),
        h(NInput, {
          value: newEmailRef.value,
          placeholder: "example@email.com",
          onUpdateValue: (value: string) => {
            newEmailRef.value = value;
          },
        }),
      ]),
    positiveText: "저장",
    negativeText: "취소",
    onPositiveClick: () => {
      const emailVal = newEmailRef.value.trim();
      if (!emailVal || !emailRegex.test(emailVal)) {
        message.error("올바른 이메일 형식을 입력해주세요.");
        return false;
      }
      d.loading = true;
      updateExamineeEmailCallable({
        examineeSK: examinee.SK,
        email: emailVal,
      })
        .then((res: any) => {
          if (common.evalFunctionResult(res)) {
            examinee.email = emailVal;
            triggerOrderProjectsUpdate();
            message.success("이메일이 성공적으로 수정되었습니다.");
            d.destroy();
          } else {
            d.loading = false;
            notification.error({
              title: "이메일 수정 실패",
              description: common.getResultError(res) || "이메일 수정에 실패했습니다.",
              duration: 3000,
            });
          }
        })
        .catch((err: any) => {
          d.loading = false;
          notification.error({
            title: "오류 발생",
            description: err.message || "이메일 수정 중 오류가 발생했습니다.",
            duration: 3000,
          });
        });

      return false;
    },
  });
}


function doSendExamineeEmail(examinee: Examinee, project: Project | undefined) {
  if (!project) return;
  if (!examinee.email) {
    message.warning("학생의 이메일 주소가 등록되지 않았습니다.");
    return;
  }
  if (!examinee.report_file) {
    message.warning("결과리포트가 아직 생성되지 않았습니다.");
    return;
  }

  const isResend = !!examinee.email_sent;
  const d = dialog.create({
    title: isResend ? "결과리포트 이메일 재전송" : "결과리포트 이메일 전송",
    type: isResend ? "warning" : "info",
    content: () =>
      h("div", { style: "display: flex; flex-direction: column; gap: 8px;" }, [
        isResend
          ? h("p", { style: "color: #e6a23c; font-weight: bold;" }, "이미 이메일이 전송된 학생입니다.")
          : null,
        h(
          "p",
          `"${examinee.name}" 학생(${examinee.email})에게 결과리포트 이메일을 ${isResend ? "다시 " : ""}전송하시겠습니까?`
        ),
      ]),
    positiveText: "전송",
    negativeText: "취소",
    onPositiveClick: () => {
      d.loading = true;
      isSendingStudentEmail.value[examinee.SK] = true;
      sendExamineeReportEmailCallable({
        projectSK: project.SK,
        examineeSK: examinee.SK,
      })
        .then((res: any) => {
          if (common.evalFunctionResult(res)) {
            const payload = res.data?.data || res.data || {};
            examinee.email_sent = true;
            examinee.email_sent_at = payload.email_sent_at || new Date().toISOString();
            triggerOrderProjectsUpdate();
            message.success("이메일이 성공적으로 전송되었습니다.");
            d.destroy();
          } else {
            d.loading = false;
            notification.error({
              title: "이메일 전송 실패",
              description: common.getResultError(res) || "이메일 전송에 실패했습니다.",
              duration: 3000,
            });
          }
        })
        .catch((err: any) => {
          d.loading = false;
          notification.error({
            title: "오류 발생",
            description: err.message || "이메일 전송 중 오류가 발생했습니다.",
            duration: 3000,
          });
        })
        .finally(() => {
          isSendingStudentEmail.value[examinee.SK] = false;
        });

      return false;
    },
  });
}





async function doRequestExamineeReport(projectSK: string) {
  isDoingJob.value = true;
  isStudentReporting.value[projectSK] = true;
  try {
    const result = await requestProjectReportGenerationCallable({
      SK: projectSK,
    });
    if (common.evalFunctionResult(result)) {
      notification.warning({
        title: "요청 성공",
        description: "리포트 생성 요청이 성공 했습니다.",
        duration: 3000,
      });
    } else {
      notification.error({
        title: "요청 실패",
        description:
          common.getResultError(result) || "리포트 생성 요청이 실패 했습니다.",
        duration: 3000,
      });
    }
  } catch (error: any) {
    notification.error({
      title: "요청 실패",
      description: error || "리포트 생성 요청이 실패 했습니다.",
      duration: 3000,
    });
  } finally {
    isStudentReporting.value[projectSK] = false;
    isDoingJob.value = false;
  }
}

async function doRequestProjectClose(projectSK: string) {
  isDoingJob.value = true;
  isProjectClosing.value[projectSK] = true;
  try {
    const result = await closeOneProjectCallable({
      SK: projectSK,
    });
    if (common.evalFunctionResult(result)) {
      notification.warning({
        title: "요청 성공",
        description: "검사 종료 및 이메일 전송요청이 성공 했습니다.",
        duration: 3000,
      });
    } else {
      notification.error({
        title: "요청 실패",
        description:
          common.getResultError(result) ||
          "검사 종료 및 이메일 전송요청이 실패 했습니다.",
        duration: 3000,
      });
    }
  } catch (error: any) {
    notification.error({
      title: "요청 실패",
      description: error || "검사 종료 및 이메일 전송요청이 실패 했습니다.",
      duration: 3000,
    });
  } finally {
    isProjectClosing.value[projectSK] = false;
    isDoingJob.value = false;
  }
}

async function doOpenProject(projectSK: string) {
  pageLoading.value = true;
  try {
    const result = await openOneProjectCallable({ SK: projectSK });
    if (common.evalFunctionResult(result)) {
      notification.warning({
        title: "요청 성공",
        description: "검사 오픈 요청이 성공 했습니다.",
        duration: 3000,
      });
    } else {
      notification.error({
        title: "요청 실패",
        description:
          common.getResultError(result) || "검사 오픈 요청이 실패 했습니다.",
        duration: 3000,
      });
    }
  } catch (error: any) {
    notification.error({
      title: "요청 실패",
      description: error || "검사 오픈 요청이 실패 했습니다.",
      duration: 3000,
    });
  } finally {
    pageLoading.value = false;
  }
}

async function downloadExamineeReportFile(
  examineeItem: Examinee,
  classType?: string
) {
  isDoingJob.value = true;
  isDownloadingStudentReport.value[examineeItem.SK] = true;
  let typePrefix = "";
  if (classType) {
    typePrefix = classType.split("_")[0].toUpperCase() + "-";
  }
  let filename = `${typePrefix}${examineeItem.name}.pdf`;
  await downloadReportFile(examineeItem.report_file, filename);
  isDownloadingStudentReport.value[examineeItem.SK] = false;
  isDoingJob.value = false;
}

function handleCancel() {
  router.push({ name: USER_ROUTES.Mypage.Order.Personal.Name });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(Loading, null, null, 512), [
      [_vShow, pageLoading.value]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MyPageSidebar),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(NSpace), { vertical: "" }, {
            default: _withCtx(() => [
              _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px","max-width":"1000px"} }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSpace), {
                    "item-style": "display: flex;",
                    align: "center",
                    justify: "space-between"
                  }, {
                    default: _withCtx(() => [
                      _cache[1] || (_cache[1] = _createElementVNode("div", { style: {"font-size":"20px","font-weight":"bold"} }, " 검사 정보 조회 ", -1)),
                      _createVNode(_unref(NButton), {
                        onClick: refreshData,
                        type: "tertiary",
                        size: "small"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(NIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(RefreshIcon))
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _cache[0] || (_cache[0] = _createTextVNode(" 새로고침 "))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
                  (pageLoading.value)
                    ? (_openBlock(), _createBlock(Loading, { key: 0 }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_5, [
                    (orderProjectEntries.value && orderProjectEntries.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderProjectEntries.value, (classItem, classIdx) => {
                              return (_openBlock(), _createBlock(_unref(NCard), {
                                key: classItem.SK || `class-${classIdx}`,
                                title: getClassTitle(classItem, classIdx),
                                size: "small",
                                style: {"margin-bottom":"25px","border":"1px solid #dcdfe6","box-shadow":"0 1px 5px rgba(0, 0, 0, 0.07)"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NDescriptions), {
                                    "label-placement": "left",
                                    column: 2,
                                    bordered: "",
                                    size: "small",
                                    style: {"margin-bottom":"15px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NDescriptionsItem), { label: "진단이름" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(classItem.name || "N/A"), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_unref(NDescriptionsItem), { label: "상태" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("span", null, _toDisplayString(_unref(getProjectStatusString)(classItem.status)), 1),
                                            (
                                classItem.status ===
                                constant.projectStatus.PENDING
                              )
                                              ? (_openBlock(), _createBlock(_unref(NButton), {
                                                  key: 0,
                                                  style: {"margin-left":"10px"},
                                                  type: "primary",
                                                  onClick: ($event: any) => (doOpenProject(classItem.SK))
                                                }, {
                                                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                    _createTextVNode(" 진단검사 실시 ")
                                                  ])),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_unref(NDescriptionsItem), { label: "진단 시작일" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(common.getYYYMMDDStringFormat(
                              classItem.start_target_date
                            )), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_unref(NDescriptionsItem), { label: "진단 종료일" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(common.getYYYMMDDStringFormat(
                              classItem.end_target_date
                            )), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (
                            classItem.status == constant.projectStatus.READY ||
                            classItem.status == constant.projectStatus.ING
                          )
                                        ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                                            key: 0,
                                            label: "검사 링크",
                                            span: 2
                                          }, {
                                            default: _withCtx(() => [
                                              (classItem.responder_uri)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createElementVNode("a", {
                                                      href: common.getSurveyUrl(classItem.SK!),
                                                      target: "_blank",
                                                      rel: "noopener noreferrer"
                                                    }, _toDisplayString(common.getSurveyUrl(classItem.SK!)), 9, _hoisted_8),
                                                    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                                    _cache[4] || (_cache[4] = _createElementVNode("span", { style: {"color":"red"} }, "※ 위 검사 링크를 누르면 검사를 시작할 수 있습니다. ", -1))
                                                  ], 64))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createTextVNode(" N/A ")
                                                  ], 64))
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true),
                                      (
                            classItem.status == constant.projectStatus.READY ||
                            classItem.status == constant.projectStatus.ING
                          )
                                        ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                                            key: 1,
                                            label: "",
                                            span: 2
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(NTooltip), { trigger: "hover" }, {
                                                trigger: _withCtx(() => [
                                                  _createVNode(_unref(NButton), {
                                                    disabled: isDoingJob.value,
                                                    loading: isStudentReporting.value[classItem.SK],
                                                    type: "primary",
                                                    onClick: ($event: any) => (doRequestExamineeReport(classItem.SK)),
                                                    style: {"margin-left":"10px"}
                                                  }, {
                                                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                      _createTextVNode(" 결과리포트 생성 요청 ")
                                                    ])),
                                                    _: 2
                                                  }, 1032, ["disabled", "loading", "onClick"])
                                                ]),
                                                default: _withCtx(() => [
                                                  _createTextVNode(" " + _toDisplayString(getClassTitle(classItem, classIdx)) + "에 대한 리포트 생성을 요청합니다. ", 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_unref(NTooltip), { trigger: "hover" }, {
                                                trigger: _withCtx(() => [
                                                  _createVNode(_unref(NButton), {
                                                    disabled: isDoingJob.value,
                                                    loading: isProjectClosing.value[classItem.SK],
                                                    type: "primary",
                                                    onClick: ($event: any) => (doRequestProjectClose(classItem.SK)),
                                                    style: {"margin-left":"10px"}
                                                  }, {
                                                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                                                      _createTextVNode(" 검사 종료 및 결과리포트_학생용 전송 요청 ")
                                                    ])),
                                                    _: 2
                                                  }, 1032, ["disabled", "loading", "onClick"])
                                                ]),
                                                default: _withCtx(() => [
                                                  _createTextVNode(" " + _toDisplayString(getClassTitle(classItem, classIdx)) + "의 검사를 종료하고, 검사결과를 이메일로 전송하도록 요청합니다. ", 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (
                          classItem.examinees && classItem.examinees.length > 0
                        )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _cache[7] || (_cache[7] = _createElementVNode("div", { style: {"width":"100%","display":"flex","justify-content":"flex-end"} }, [
                                          _createElementVNode("span", { style: {"color":"red"} }, "※ 검사를 시작하기 전에 인증코드를 반드시 기억해야 합니다. ")
                                        ], -1)),
                                        _createVNode(ExamineeTable, {
                                          examinees: classItem.examinees,
                                          classType: classItem.type,
                                          project: classItem
                                        }, null, 8, ["examinees", "classType", "project"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_10, " 등록된 학생 정보가 없습니다. "))
                                ]),
                                _: 2
                              }, 1032, ["title"]))
                            }), 128))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, " 진단 정보를 불러오지 못했습니다. "))
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_unref(NButton), {
                  type: "primary",
                  onClick: handleCancel
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode(" 목록으로 ")
                  ])),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})